export const qtdDependentesMaiorIgual65anos = dependentes => {
    const qtdDependentes = dependentes.filter(({ Idade }) => Idade >= 65).length;
    const quantidadeMaximaDeDependentesMaiorIgual65Permitidas = 2;

    return qtdDependentes === quantidadeMaximaDeDependentesMaiorIgual65Permitidas;
};

const parentescosPermitidosEstrutura1 = ['10', '01', '02', '15', '20007', '20008', '32', '5', '50'];

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVÔ',
    'PET': 'PET (ANIMAL)'
};

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

export const estaDentroDaEstrutura1 = valores => {
    const { Parentesco, Idade } = valores;
    const parentescoPermitido = parentescosPermitidosEstrutura1.includes(Parentesco.trim());

    const idadeMaximaPermitidaFilhos = 30;

    if ((Parentesco.trim() === '50' || Parentesco.trim() === '5') && Idade > idadeMaximaPermitidaFilhos) {
        return false;
    }

    return parentescoPermitido;
};

export const validaDependentesEstrutura1 = (dependentes, values) => {
    if (values.Seq) {
        return false;
    }

    const possuiDependentesForaDaEstrutura1 = dependentes.find(dependente => {
        const Parentesco = dependente['GrauParentesco.Grau'];
        const Idade = dependente.Idade;

        const values = {
            Parentesco,
            Idade
        };

        return !estaDentroDaEstrutura1(values);
    });

    return possuiDependentesForaDaEstrutura1 ? true : false;
};

const quantidadeMaximaPermitidaDeDependentes = 9;

const verificaEstaDentroDaEstrutura1 = (dependentes, values) => {
    const naoAtigiuOLimiteDeDependentes = dependentes.length <= quantidadeMaximaPermitidaDeDependentes;

    if (naoAtigiuOLimiteDeDependentes && values.Seq) {
        return false;
    }

    return !estaDentroDaEstrutura1(values);
};

const verificaEstaEditando = values => values.Seq ? true : false;

export const validatorMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [

        verificarIdadePreenchida(valoresForm.Idade),
        idadeAte65(valoresForm.Idade),
        qtdDependentesMaiorIgual65anos(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        const grausEquivalente = grausEquivalentes[`${parentesco.trim()}`];

        const possuiParentescoEquivalente = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === grausEquivalente);

        return possuiParentescoEquivalente.length ? seq ? seq !== possuiParentescoEquivalente[0].Seq : true : false;
    }

    if (parentesco.trim() === '15') {
        return possuiParentescoSelecionado.length === 2 ? true : false;
    }

    if (parentesco.trim() === 'AVô') {
        return possuiParentescoSelecionado.length === 4 ? true : false;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const validatorEstrtutura1 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [

        !estaDentroDaEstrutura1(valoresForm)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPossui9Dependentes = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        qtdDependentes(dependentes),
        !verificaEstaEditando(valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const idadeAte65 = idade => idade >= 65;
const qtdDependentes = dependentes => dependentes.length === quantidadeMaximaPermitidaDeDependentes;

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();
    const grauEquivalente = grausEquivalentes[parentesco];

    if (parentesco === '15' || parentesco === '10006') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]} / ${parentescos[`${grauEquivalente}`]}`;
};
